import { render, staticRenderFns } from "./Section5.vue?vue&type=template&id=04b91f94&scoped=true&"
import script from "./Section5.vue?vue&type=script&lang=js&"
export * from "./Section5.vue?vue&type=script&lang=js&"
import style0 from "./Section5.vue?vue&type=style&index=0&id=04b91f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b91f94",
  null
  
)

export default component.exports